import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { finalize } from 'rxjs/operators';
import { MicromedidoresService } from './../../../../../monitoreo/services/micromedidores.service';
import { Micromedidor } from './../../../../../../_entities/micromedidores/micromedidor';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment';
import { SolarSystemObject, Service } from './app.service'; /*este es una prueba del demo*/
import { AuthService } from '../../../../../auth/auth.service'; /*este es una prueba del demo*/
import { User } from '../../../../../../_entities/User'; /*este es una prueba del demo*/

const MESES = [
	{ valor: 0, etiqueta: 'Enero', dias: 31 },
	{ valor: 1, etiqueta: 'Febrero', dias: 29 },
	{ valor: 2, etiqueta: 'Marzo', dias: 31 },
	{ valor: 3, etiqueta: 'Abril', dias: 30 },
	{ valor: 4, etiqueta: 'Mayo', dias: 31 },
	{ valor: 5, etiqueta: 'Junio', dias: 30 },
	{ valor: 6, etiqueta: 'Julio', dias: 31 },
	{ valor: 7, etiqueta: 'Agosto', dias: 31 },
	{ valor: 8, etiqueta: 'Septiembre', dias: 30 },
	{ valor: 9, etiqueta: 'Octubre', dias: 31 },
	{ valor: 10, etiqueta: 'Noviembre', dias: 30 },
	{ valor: 11, etiqueta: 'Diciembre', dias: 31 }
]
@Component({
	selector: 'kt-historico-mediciones-micromedidor',
	templateUrl: './historico-mediciones-micromedidor.component.html',
	styleUrls: ['./historico-mediciones-micromedidor.component.scss'],
	providers: [Service] /*este es una prueba del demo*/
})
export class HistoricoMedicionesMicromedidorComponent implements OnInit {
/*este es una prueba del demo*/
_user: User;
	public usuarioDemo: boolean = true;
	dato: SolarSystemObject[];
	lineStyles: Array<string> = ['waved', 'straight'];

  breaksCount: Array<number> = [1, 2, 3, 4];

  lineStyleValue: string;

  autoBreaksEnabledValue = true;

  breaksCountValue: number;

  title = 'Consumo de agua por mes (en Litros)';

/*este es una prueba del demo*/
	public micromedidor: Micromedidor;
	public mediciones;
	public fechaInicio;
	public fechaFin;
	public mesValue = new Date().getMonth();
	public anio = new Date().getFullYear();
	public mesActual;
	public mesAnterior;

	public volumenInicial;
	public fechaInicial;
	public volumenFinal;
	public fechaFinal;

	public volumenPromedio;

	public visualRange = {};

	public showGrafica: boolean = false;
	public loadingVisible: boolean = false;

	longtabs = [
		{ titulo: 'Volumen' }
	];

	constructor(private dialogRef: MatDialogRef<HistoricoMedicionesMicromedidorComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private micromedidoresService: MicromedidoresService, service: Service /*este es una prueba del demo*/,private auth: AuthService /*este es una prueba del demo*/, 
		private toastService: ToastrService,
		private datepipe: DatePipe) { 
			this.dato = service.getData();/*este es una prueba del demo*/
    this.lineStyleValue = this.lineStyles[0];/*este es una prueba del demo*/
    this.breaksCountValue = this.breaksCount[2];/*este es una prueba del demo*/
		}

	ngOnInit() {
		/*este es una prueba del demo*/
		this._user = this.auth.getUser();
		if(this._user.id === "6cac2e07-cb6d-4725-93d7-ed7ad39f5ade"){
			this.usuarioDemo = false;
		}
		/*este es una prueba del demo*/
		this.micromedidor = this.data;
		console.log("mes actual" , this.mesValue)
		this.mesActual = MESES.find(mes => this.mesValue === mes.valor);
		if(this.mesValue == 0){
			this.mesValue = 11;
			this.mesAnterior = MESES.find(mes => this.mesValue  === mes.valor);
		}else{
			this.mesAnterior = MESES.find(mes => this.mesValue - 1 === mes.valor);
		}
	}

	valueItems(arg) {
		return arg.valueText + ' Litros';
	}

	obtenerHistorico(fechaInicio, fechaFin, tipoConsulta) {
		this.showGrafica = false;
		this.loadingVisible = true;
		let fechaInicial = this.datepipe.transform(fechaInicio, "yyyy-MM-dd HH:mm:ss");
		let fechaFinal = this.datepipe.transform(fechaFin, "yyyy-MM-dd HH:mm:ss");

		/**
		 * Contador = Volumen
		 * Gasto = Consumo
		 * */

		this.micromedidoresService.obtenerHistoricoMediciones(this.micromedidor.numeroSerie, fechaInicial, fechaFinal).pipe(
			finalize(
				() => this.loadingVisible = false
			)
		).subscribe(
			(micromedidores: Micromedidor[]) => {
				if (micromedidores.length > 0) {

					micromedidores.map(micromedidor => {
						if (micromedidor.contador == "NaN") {
							micromedidor.contador = 0;
						}
						if (micromedidor.tamper == "NaN") {
							micromedidor.tamper = 0;
						}
						micromedidor.fhRegistro = this.datepipe.transform(micromedidor.fhRegistro, 'yyyy-MM-dd HH:mm');
					});

					const fecha1 = moment(this.datepipe.transform(fechaInicial, 'yyyy-MM-dd'));
					const fecha2 = moment(this.datepipe.transform(fechaFinal, 'yyyy-MM-dd'));

					const difereciaDias = fecha2.diff(fecha1, 'days');

					if (difereciaDias < 3) {
						tipoConsulta = 'dia';
					} else {
						tipoConsulta = 'mes';
					}

					this.fechaInicial = fechaInicial;
					this.fechaFinal = fechaFinal;

					this.volumenInicial = micromedidores[0].contador;
					this.volumenFinal = micromedidores[micromedidores.length - 1].contador;

					this.mediciones = this.sumarGastoDia(micromedidores);
					this.obtenerGastoPromedio(this.mediciones);

					this.showGrafica = true;

					/*switch (tipoConsulta) {
						case 'rango':
							this.mediciones = micromedidores;
							this.obtenerGastoPromedio(this.mediciones);

							this.volumenInicial = micromedidores[0].contador;
							this.volumenFinal = micromedidores[micromedidores.length - 1].contador;

							this.showGrafica = true;
							break;
						case 'dia':
							micromedidores.map(micromedidor => {
								micromedidor.fhRegistro = this.datepipe.transform(micromedidor.fhRegistro, 'HH:00:00')
							});
							this.mediciones = this.sumarGastoDia(micromedidores);
							console.log(this.mediciones);

							this.obtenerGastoPromedio(this.mediciones);

							this.volumenInicial = micromedidores[0].contador;
							this.volumenFinal = micromedidores[micromedidores.length - 1].contador;

							this.showGrafica = true;
							break;
						case 'mes':
							micromedidores.map(medidor => {
								medidor.fhRegistro = this.datepipe.transform(medidor.fhRegistro, 'yyyy-MM-dd');
							});
							this.mediciones = this.sumarGastoDia(micromedidores);
							this.obtenerGastoPromedio(this.mediciones);

							this.volumenInicial = micromedidores[0].contador;
							this.volumenFinal = micromedidores[micromedidores.length - 1].contador;

							this.showGrafica = true;
							break;
						case 'año':
							micromedidores.map(medidor => {
								medidor.fhRegistro = this.datepipe.transform(medidor.fhRegistro, 'yyyy-MM-dd');
							});
							let gastoDiario = this.sumarGastoDia(micromedidores);
							this.sumarGastoSemana(gastoDiario);

							this.volumenInicial = micromedidores[0].contador;
							this.volumenFinal = micromedidores[micromedidores.length - 1].contador;
							this.showGrafica = true;
							break;
					}*/

					if (this.mediciones.length > 1) {
						this.visualRange = {
							startValue: this.mediciones[0].fhRegistro,
							endValue: this.mediciones[2].fhRegistro
						};
					}
				} else {
					this.toastService.info('No hay información de esta consulta');

				}
			}, (error) => {
				this.toastService.info(error.error)
			}
		)

	}

	obtenerGastoPromedio(datos) {
		let volumenTotal = 0;

		datos.forEach(dato => {
			volumenTotal = volumenTotal + dato.contador;
		});

		this.volumenPromedio = (volumenTotal / (datos.length)).toFixed(2);
	}

	//Obtenemos el consumo diario del medidor
	sumarGastoDia(datos) {
		let nuevoObjeto = {}
		let gastoTotal;
		let nuevaRespuesta = [];

		//Recorremos el arreglo
		datos.forEach(x => {
			//Si la fecha no existe en nuevoObjeto, entonces la creamos e inicializamos el arreglo de datos.
			x.fhRegistro = this.datepipe.transform(x.fhRegistro, 'yyyy-MM-dd');

			if (!nuevoObjeto.hasOwnProperty(x.fhRegistro)) {
				nuevoObjeto[x.fhRegistro] = {
					datos: []
				}

				nuevoObjeto[x.fhRegistro].datos.push({
					fhRegistro: x.fhRegistro,
					contador: x.contador
				});

			} else {
				//Agregamos los datos al arreglo datos.
				nuevoObjeto[x.fhRegistro].datos.push({
					fhRegistro: x.fhRegistro,
					contador: x.contador
				});
			}
		})

		const keys = Object.keys(nuevoObjeto);

		keys.forEach(key => {
			gastoTotal = 0;

			let totalDatos = nuevoObjeto[key].datos.length;

			let datoInicial = nuevoObjeto[key].datos[0].contador;
			let datoFinal = nuevoObjeto[key].datos[totalDatos - 1].contador;
			/*nuevoObjeto[key].datos.forEach(dato => {
				gastoTotal = gastoTotal + dato.contador
			});*/

			gastoTotal = datoFinal - datoInicial
			let form = {
				fhRegistro: key,
				contador: Number(gastoTotal.toFixed(2))
			}
			nuevaRespuesta.push(form);
		});
		return nuevaRespuesta
	}

	sumarGastoSemana(gastoDiario) {
		let nuevaRespuesta;
		let gastoTotal = 0;

		if (gastoDiario.length > 7) {
		} else {
			gastoDiario.forEach(dato => {
				gastoTotal = gastoTotal + dato.gasto
			});

			let form = {
				fechaHora: 'semana 1',
				gasto: Number(gastoTotal.toFixed(2))
			}
			nuevaRespuesta.push(form);
		}
		return nuevaRespuesta
	}

	obtenerReporteHoy() {
		const fechaInicio = this.datepipe.transform(new Date(), 'yyyy-MM-dd 00:00:00');
		const fechaFinal = this.datepipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');

		this.obtenerHistorico(fechaInicio, fechaFinal, 'hoy');
	}

	obtenerReporteMes() {
		const fechaInicio = this.datepipe.transform(new Date(), 'yyyy-MM-01 00:00:00');
		const fechaFinal = this.datepipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');

		this.obtenerHistorico(fechaInicio, fechaFinal, 'mes');
	}

	obtenerReporteMesAnterior() {
		const fecha = new Date();
		const mesValue = fecha.getMonth() - 1;

		fecha.setMonth(mesValue);

		const mes = MESES.find(mes => mes.valor === mesValue);
		const fechaInicio = `${fecha.getFullYear()}-${(fecha.getMonth() + 1)}-01 00:00:00`;
		const fechaFinal = `${fecha.getFullYear()}-${(fecha.getMonth() + 1)}-${mes.dias} 23:59:59`;

		this.obtenerHistorico(fechaInicio, fechaFinal, 'mes');

	}

	obtenerReporteTresMeses() {
		const fecha = new Date();
		const mesValue = fecha.getMonth() - 3;

		fecha.setMonth(mesValue);

		const fechaInicio = `${fecha.getFullYear()}-${(fecha.getMonth() + 1)}-01 00:00:00`;
		const fechaFinal = this.datepipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');

		this.obtenerHistorico(fechaInicio, fechaFinal, 'mes');

	}

	obteneReporteAnio() {
		const fechaInicio = this.datepipe.transform(new Date(), 'yyyy-01-01 00:00:00');
		const fechaFinal = this.datepipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');

		this.obtenerHistorico(fechaInicio, fechaFinal, 'año');
	}

	etiquetaModificada(arg) {
		return {
            text: arg.valueText + ' Litros'
        };
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}

}
